import { render, staticRenderFns } from "./ResponsiveRowLarge.vue?vue&type=template&id=5548873f&scoped=true"
import script from "./ResponsiveRowLarge.vue?vue&type=script&lang=ts"
export * from "./ResponsiveRowLarge.vue?vue&type=script&lang=ts"
import style0 from "./ResponsiveRowLarge.vue?vue&type=style&index=0&id=5548873f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5548873f",
  null
  
)

export default component.exports